import { createAemUrl, createProxyUrl } from "./createUrls";

const isAbsolutePathContentUrl = (url: string) => url.match(/^\/content\//);

// this environment knowing about other environments is an anti-pattern
// please do not spread usage of this any further
// cross-environment linking is architecture technical debt
const AEM_BASES = [
  "https://contentqa.fordpro.com",
  "https://content.fordpro.com",
];

const isFullAemBaseUrl = (url: string) =>
  AEM_BASES.some((base) => url.startsWith(base));

export const augmentUrl = (url: string, aemBaseUrl: string) => {
  let augmentedUrl = url;

  if (isAbsolutePathContentUrl(augmentedUrl)) {
    augmentedUrl = createAemUrl(aemBaseUrl, augmentedUrl);
  }

  if (isFullAemBaseUrl(augmentedUrl)) {
    augmentedUrl = createProxyUrl(augmentedUrl);
  }

  return augmentedUrl;
};
